import { render, staticRenderFns } from "./Genres.vue?vue&type=template&id=40feb6d4&scoped=true&"
import script from "./Genres.vue?vue&type=script&lang=js&"
export * from "./Genres.vue?vue&type=script&lang=js&"
import style0 from "./Genres.vue?vue&type=style&index=0&id=40feb6d4&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "40feb6d4",
  null
  
)

export default component.exports